import { render } from "./Be.vue?vue&type=template&id=1b87aaf3"
import script from "./Be.vue?vue&type=script&lang=js"
export * from "./Be.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sr.vlas/vendor/v-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__